import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  protected get apiUrl() {
    return environment.serverUrl;
  }
  constructor(protected readonly httpClient: HttpClient) {}
}
